export default "__VITE_ASSET__CkgcXEQm__"